import { SpareInOutService } from '../service/spare-in-out.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SparepartService } from '../services/sparepart.service';
import { SpareInOut } from '../models/spareinout';

let ELEMENT_DATA = [];

@Component({
  selector: 'app-item-check-report',
  templateUrl: './item-check-report.component.html',
  styleUrls: ['./item-check-report.component.scss']
})
export class ItemCheckReportComponent implements OnInit {


  showItemDetails : boolean = true;

  constructor(
  ) { }

  ngOnInit() {
  }

}
